// src/utils/userInfo.js
// Utility functions to get user name and initials from Supabase user info in localStorage

export function getUserName() {
  const user = JSON.parse(localStorage.getItem("employee"));
  const name = user?.employee_name;
  if (name) return name;
  return "User";
}

export function getUserInitials() {
  try {
    const user = JSON.parse(localStorage.getItem("employee"));
    const name = user?.employee_name;
    if (name) {
      return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    } else if (user?.email) {
      return user.email[0].toUpperCase();
    }
  } catch (e) {}
  return "U";
}
